const mutations = {
    setMockCompany(state,payload){
        state.MockCompanyID = payload
    },
    setCompaniesForMocker(state,payload){
        state.companies = payload
    }
}

export default mutations
